import React from 'react';
import { Divider, Typography } from '@mui/material';
import narikel from '../../../../../images/Agri-info/crops/narikel_নারিকেল.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const NarikelInfo = () => {

    // dynamic title
    useDocumentTitle("নারিকেল");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h4"
                noWrap
                component="div"
            >
                নারিকেল
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={narikel} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>পুষ্টি মূল্য : </b><br />ডাবের পানিতে ক্যালসিয়াম, ফসফরাস ও অন্যান্য পুষ্টি উপাদান রয়েছে। নারিকেলের শাঁসে স্নেহ জাতীয় পদার্থের পরিমান বেশি থাকে।</p>
                            <p className="card-text"><b>ভেষজ গুণ: </b><br />এটি পিত্তনাশক ও কৃমিনাশক। ফলের মালা/আইচা পুড়িয়ে পাথরবাটি চাপা দিয়ে পাথরের গায়ে যে গাম/ কাই হয় তা দাদ রোগের জন্য মহৌষোধ। </p>
                            <p className="card-text"><b>ব্যবহার: </b><br />পানীয় হিসেবে ব্যবহারের পাশাপাশি নারিকেল গাছের প্রতিটি অঙ্গই কোন না কোন কাজে লাগে।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p className="card-text"><b>উপযুক্ত জমি ও মাটি: </b><br />নারিকেল গাছের জন্য নিকাশযুক্ত  দোআঁশ থেকে পলি দোআঁশ মাটি উত্তম।</p>
                <p><b>জাত পরিচিতি:</b></p>
                <p className="card-text"><b>বারি নারিকেল-১: </b>গাছ মধ্যম আকৃতির এবং সারা বছর ফল ধরে। পূর্ণ বয়ষ্ক প্রতিটি গাছে ফলের সংখ্যা ৬৫-৭৫ টি। এ জাতটি কান্ড ঝরা রোগ সহনশীল। তেলের পরিমান ৫৫-৬০%।</p>
                <p className="card-text"><b>বারি নারিকেল-২: </b>এটি সারা দেশে চাষযোগ্য একটি উচ্চ ফলনশীল জাত। পূর্ণ বয়ষ্ক প্রতিটি গাছে ফলের সংখ্যা ৬৫-৭৫ টি। ফলের আকৃতি প্রায় ডিম্বাকার। তেলের পরিমান ৫০-৫৫%। পাতায় দাগ রোগ সহনশীল। দেশের দক্ষিণাঞ্চলের জন্য এ জাত বেশি উপযোগী।</p>
                <p className="card-text"><b>চারা তৈরি: </b>নারিকেল হতে বীজ নারিকেল তৈরি করা হয়।</p>
                <p className="card-text"><b>চারা রোপণ: </b><br />মধ্য জ্যৈষ্ঠ থেকে মধ্য আশ্বিন মাস চারা রোপনের জন্য উপযুক্ত সময়। লাইন থেকে লাইন এবং গাছ থেকে গাছের দূরত্ব ৮ মিটার করে রাখা দরকার। প্রতি একরে ৬৩ টি চারা রোপণ করা যায়।</p>
                <p className="card-text"><b>সার ব্যবস্থাপনা: </b><br />রোপণের আগে চারিদিকে ১ মিটার করে গর্ত তৈরি করে নিয়ে প্রতি গর্তে টিএসপি সার ২৫০ গ্রাম, এমওপি সার ৪০০ গ্রাম ও গোবর ১০ কেজি প্রয়োগ করতে হয়। তবে পূর্ণবয়স্ক গাছের ক্ষেত্রে সারের পরিমান বাড়াতে হবে।  প্রতি বছর ১০ কেজি পরিমান গোবর সার প্রয়োগ করতে হয়। সমস্ত সার দুইভাগে প্রয়োগ করতে হয়। এক ভাগ মধ্য বৈশাখ থেকে মধ্য আষাঢ় ও অন্যভাগ মধ্য ভাদ্র থেকে মধ্য কার্তিক মাসে প্রয়োগ করতে হয়। গাছের গোড়া থেকে অন্তত: ১.৭৫ দূরে বৃত্তাকার রিং করে সার প্রয়োগ করতে হয়। গাছে পটাশিয়াম ও বোরণের অভাব হলে ফল ঝরে পড়ে।</p>
                <p className="card-text"><b>সেচ ও আগাছা ব্যবস্থাপনা: </b><br />শুকনো মৌসুমে ১৫ দিন পরপর ২-৩ বার সেচ দেওয়া উত্তম। তবে বর্ষা মৌসুমে পানি নিকাশ করা দরকার।</p>
                <p className="card-text"><b>ফসল তোলা: </b><br />ফুল ফোটার পর ১১-১২ মাস পর ফল সংগ্রহের উপযুক্ত হয়। পাকা অবস্থায় নারকেলেরর রঙ সবুজ থেকে বাদামি/ খয়েরি রঙ ধারণ করে। </p>

            </div>
        </div >

    );
};

export default NarikelInfo;